<template>
    <div class="form-wrapper">
        <v-form v-model="valid" @submit="onSubmit" onSubmit="return false;">
            <v-container>
                <v-row>
                    <v-text-field
                            v-model="name"
                            :rules="nameRules"
                            :counter="30"
                            label="Title"
                            required
                    ></v-text-field>

                </v-row>


            </v-container>
        </v-form>

    </div>
</template>

<script>

    import * as _ from "lodash";

    export default {
        name: "GroupForm",
        computed: {

            name: {
                get() {
                    return this.$store.state.selectedModel ?
                        this.$store.state.selectedModel.name :
                        null;
                },
                set(value) {
                    this.$store.dispatch("updateProperty", {propertyName: "name", value: value});
                },
            }
        },
        data: () => ({
            valid: false,
            nameRules: [
                v => !!v || "Name is required",
                v => v && v.length <= 30 || "Name must be less than 30 characters.",
            ],
            email: "",
            emailRules: [
                v => !!v || "E-mail is required",
                v => /.+@.+/.test(v) || "E-mail must be valid",
            ],
        }),
        methods: {
            onSubmit(e) {
                return false;
            },
            onInputEnter() {

                return false;
            }
        }
    }
</script>

<style scoped>
    .form-wrapper {
        margin: 10px;
    }
</style>
